import React from 'react'
import { IconButton, LinearProgress } from "@material-ui/core";
import { CurrentImageImage, DeleteMask, ImageContainer, ResponsiveStyles } from "../ProductImages.styles";
import DeleteIcon from '@material-ui/icons/Delete';
import { CheckCircle } from '@material-ui/icons';

export const CurrentImage = ({ image, alt, handleClick, handleSetAsProductCover, isProductCover, isDeleting, wide = false, thumb = false }) => {
  const classes = ResponsiveStyles();

  return (
    <ImageContainer wide={wide} thumb={thumb} className={classes.inBlock}>
      {isDeleting && <LinearProgress style={{ zIndex: '6' }} />}
      <CurrentImageImage
        src={image}
        alt={alt}
        className={isProductCover ? classes.mainProductCover : ''}
        style={{
          width: '150px',
          height: '150px',
          objectFit: 'cover',
          borderRadius: '10px'
        }}
      />
      <DeleteMask className="delete-mask" wide={wide}>
        <IconButton onClick={handleSetAsProductCover} aria-label="set as cover image" color="primary">
          <CheckCircle />
        </IconButton>
        <IconButton disabled={isDeleting} onClick={handleClick} aria-label="delete" color="secondary">
          <DeleteIcon />
        </IconButton>
      </DeleteMask>
      {isProductCover && (<span style={{ fontWeight: 700 }}>Foto principal</span>)}
    </ImageContainer>
  )
}